import URI from "urijs";
import AppConfig from "util/AppConfig";
const assetPrefix = AppConfig.gl2DevMode() ? "/" : "/assets/";
__webpack_public_path__ = URI.joinPaths(AppConfig.gl2AppPathPrefix(), assetPrefix).path() || assetPrefix;
